// extracted by mini-css-extract-plugin
export default {"hide":"banner-hide-CgGWTz","messages":"banner-messages-An2cG2"};